import oget from 'oget';

const parseJudgeScores = (item) => {
  const [scoreData] = oget(item, 'groups', []).filter((scoreData) => oget(scoreData, 'fields[0]') === 'Judge');

  const scores = oget(scoreData, 'details', [])
    .sort((a, b) => {
      if (a === b) {
        return 0;
      }

      return a > b;
    })
    .map((score) => ({
      judge: oget(score, 'values[0]'),
      rank: oget(score, 'values[1]'),
      drop: `${oget(score, 'values[2]')}`.toLowerCase() === 'true',
    }));

  return {
    label: scoreData.name || 'Judges',
    scores,
  };
};

const parseAthleteDetailsScored = (details) =>
  details.reduce((obj, detail) => {
    oget(detail, 'details', []).forEach((item) => {
      let type = detail.name;

      if (oget(item, 'values[0]', '').toLowerCase().substr(0, 5) === 'trick') {
        type = 'Tricks';
      }

      if (oget(item, 'values[0]', '').toLowerCase().substr(0, 3) === 'run') {
        type = 'Runs';
      }

      const value =
        detail.name === 'Needs'
          ? {
              rank: oget(item, 'values[0]'),
              points: oget(item, 'values[1]'),
            }
          : {
              rank: oget(item, 'values[1]'),
              highlight: `${oget(item, 'values[2]')}`.toLowerCase() === 'true',
              drop: `${oget(item, 'values[5]')}`.toLowerCase() === 'true',
            };
      if ((type === 'Runs' || type === 'Tricks') && `${oget(item, 'values[4]')}`.toLowerCase() === 'true') {
        obj.Current = value;
      }

      obj[type] = obj[type] || {};
      obj[type].values = obj[type].values || [];
      obj[type].label = oget(item, 'values[3]', type);

      if (type === 'Runs') {
        const { label, scores } = parseJudgeScores(item);

        if (scores.length) {
          obj[type].judgesLabel = label;
          value.judges = scores;
        }
      }

      if (value.rank === '' || value.rank === null) {
        return;
      }

      if (type === 'Runs' || type === 'Tricks') {
        value.rank =
          value.rank === null || value.rank === undefined || value.rank === '0.00' || value.rank === '0.0'
            ? 'X'
            : value.rank;

        if (value.rank === 'X') {
          value.highlight = false;
        }
      }

      obj[type].values.push(value);
    });

    return obj;
  }, {});

export default parseAthleteDetailsScored;
